import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tablet } from '@hellodarwin/core/lib/components/common/Media';
import { useMemo } from 'react';
import useLogoutLink from '../../../../hooks/use-logout-link';
import DesktopUserMenu from './desktop';
import MobileUserMenu from './mobile';
const UserMenu = (props) => {
    const { links, user, mobileVariant = 'navigation' } = props;
    const logoutLink = useLogoutLink();
    const items = useMemo(() => {
        return [...links, logoutLink];
    }, [links]);
    if (!user)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Tablet, { direction: "up", children: _jsx(DesktopUserMenu, Object.assign({}, props, { links: items })) }), _jsx(Tablet, { direction: "down", children: mobileVariant === 'dropdown' ? (_jsx(DesktopUserMenu, Object.assign({}, props, { links: items }))) : (_jsx(MobileUserMenu, Object.assign({}, props, { links: items }))) })] }));
};
export default UserMenu;
